export default __webpack_public_path__ + "static/rate-b13c8fba2bb128e5cb42363f9fd5699a.jpg";